// The backend reports this restriction as code "422" with only a free-text
// message, e.g. "Withdrawal restriction hit: WITHDRAWALS_PER_YEAR[limit=3, current=3]".
const YEARLY_WITHDRAWAL_LIMIT_PATTERN = /WITHDRAWALS_PER_YEAR\[limit=\d+/;

export const isYearlyWithdrawalLimitError = (message: string): boolean =>
  YEARLY_WITHDRAWAL_LIMIT_PATTERN.test(message);
